import { motion } from 'framer-motion';
import { SITE_MAP } from 'globalConstants';
import { MouseEvent } from 'react';
import { motionFadeIn } from 'utils';

export const Introduction = () => {
  const registerNow = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.open(
      `/${SITE_MAP.NOTARIZATION.INDEX}/${SITE_MAP.NOTARIZATION.NOTARIZATION_DOCUMENT}`,
      '_blank',
    );
  };

  return (
    <section
      id='introduction'
      className='flex h-[100vh] bg-[url("/images/backgrounds/introduction1.webp")] bg-cover bg-fixed bg-center bg-no-repeat'
    >
      <motion.div
        initial='hidden'
        whileInView='show'
        viewport={{ once: true, amount: 0.3 }}
        className='m-auto ml-[120px] flex w-full items-center justify-center'
      >
        <div className='flex w-1/2 flex-col'>
          <motion.h1
            variants={motionFadeIn('right', 'tween', 0, 0.3)}
            className='text-[40px] leading-[48px] text-service-text'
          >
            Đăng ký
          </motion.h1>
          <motion.h1
            variants={motionFadeIn('right', 'tween', 0.2, 0.3)}
            className='mt-[13px] text-[45px] font-[600] leading-[54px] text-service-primary'
          >
            Văn phòng công chứng
          </motion.h1>
          <motion.a
            target='_blank'
            href={`/${SITE_MAP.NOTARIZATION.INDEX}/${SITE_MAP.NOTARIZATION.NOTARIZATION_DOCUMENT}`}
            variants={motionFadeIn('up', 'tween', 0.3, 0.5)}
            className='mt-[53px] flex h-[60px] w-[280px] rounded-full bg-gradient-to-r from-service-primary to-service-secondary duration-[200ms] hover:scale-[1.05]'
            onClick={registerNow}
          >
            <span className='m-auto text-[24px] font-[600] leading-[29px] text-paper'>
              Đăng ký ngay
            </span>
          </motion.a>
        </div>
        <motion.div
          variants={motionFadeIn('left', 'spring', 0.2, 1)}
          className='relative aspect-square max-w-[870px] flex-1'
        >
          <div className='absolute top-1/4 left-1/2 aspect-square w-1/4 -translate-y-1/2 rounded-full bg-[#e4e0fc]' />
          <div className='absolute bottom-1/4 right-1/2 aspect-square w-1/4 translate-y-1/2 translate-x-1/4 rounded-full bg-[#d4e1ea]' />
          <div className='absolute top-1/2 right-1/2 aspect-square w-1/2 -translate-y-1/2 translate-x-1/2 rounded-full bg-[#f9e8df]' />
          <div className='absolute inset-0 bg-[url("/images/widgets/office-notarization.webp")] bg-contain bg-center bg-no-repeat'></div>
        </motion.div>
      </motion.div>
    </section>
  );
};
